import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Vote',
  path: '/homenet/vote',
  redirect: '/homenet/vote/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Vote',
      'path': 'info',
      'meta': {
        'label': 'Vote'
      },
      'component': lazyLoading('homenet/VoteInfo')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/vote.js